'use client'

import { Suspense, lazy, useState } from 'react'

// Use dynamic import with error boundary
const Spline = lazy(() => import('@splinetool/react-spline'));

interface SplineSceneProps {
  scene: string
  className?: string
}

export function SplineScene({ scene, className }: SplineSceneProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
    setIsLoading(false);
    console.error('Failed to load Spline component');
  };

  return (
    <Suspense 
      fallback={
        <div className="w-full h-full flex items-center justify-center">
          <span className="loader"></span>
        </div>
      }
    >
      <div className={className}>
        {hasError ? (
          <div className="w-full h-full flex items-center justify-center text-red-500">
            Failed to load 3D scene. Please refresh the page.
          </div>
        ) : (
          <Spline
            scene={scene}
            onLoad={() => setIsLoading(false)}
            onError={handleError}
          />
        )}
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-background/80">
            <span className="loader"></span>
          </div>
        )}
      </div>
    </Suspense>
  )
}
